<template>
    <b-card>
        <b-alert show variant="primary" class="centerpreview">
            <strong>
            <i class="fa fa-2x fa-exclamation-circle"></i> 
              Vista Previa - Datos aún sin valor oficial
            </strong>
          </b-alert>
        <b-row>
            <b-col cols="12" sm="7"	md="7"	lg="8"	xl="8">
              <em><strong>Para:</strong></em><br>
              <b-row>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="3">
                  Doc.:
                </b-col>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="9">
                  {{ documentPrev.receptor.nro }}
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="3">
                  Razon Social:
                </b-col>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="9">
                    {{ documentPrev.receptor.razonSocial }}
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="6"	md="4"	lg="4"	xl="3">
                  Direccion:
                </b-col>
                <b-col>
                  <b-input-group>
                    <b-form-input class="input-placedark input-dark" size="md" type="text" readonly="" placeholder="Dirección " v-model="documentPrev.receptor.direccionFiscal"></b-form-input>
                    <b-input-group-text slot="append">
                        <button class="btn btn-warning btn-sm sinresultados" @click="changeDirection()"><i class="fa fa-list"></i></button>
                    </b-input-group-text>
                  </b-input-group>
                  <template v-if="verDirecciones">
                    <template v-for="(item, index) in documentPrev.direcciones" class="buscarRuc">
                    <b-list-group-item :key="index" @click="setDirection(item)" class="searcher-result">
                      {{item.direccion}}
                    </b-list-group-item>
                  </template>
                  </template>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" sm="5"	md="5"	lg="4"	xl="4">
              <em><strong>Detalles:</strong></em><br>
              <b-row>
                <b-col cols="12" sm="12"	md="6"	lg="6"	xl="6">
                  Moneda:
                </b-col>
                <b-col cols="12" sm="12"	md="6"	lg="6"	xl="6">
                  {{ moneda.descripcion }}
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                  Condicion de Pago:
                </b-col>
                <b-col v-if="typeof documentPrev.adicional != 'undefined' " cols="12" sm="12"	md="12"	lg="12"	xl="12">
                    {{ documentPrev.adicional.formadepago }}
                </b-col>
              </b-row>
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
              <b-table responsive
                :small="small"
                :items="documentPrev.items"
                :fields="items_fields"
                :outlined="outlined"
                >
                <template slot="index" slot-scope="row">{{ row.index +1 }}</template>
              </b-table>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="6">
              <em><strong>Informacion Adicional</strong></em><br>
              <b-row>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                  <b-alert show variant="success">
                    <b-row>
                      <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                        <strong>Extras:</strong>
                      </b-col>
                      <b-col v-if="typeof documentPrev.adicional != 'undefined' && documentPrev.adicional.ordenCompra" cols="12" sm="12"	md="12"	lg="12"	xl="12">
                        Orden de Compra: {{ documentPrev.adicional.ordenCompra }}<br>
                      </b-col>
                      <b-col v-if="typeof documentPrev.adicional != 'undefined' && documentPrev.adicional.fechaVencimiento" cols="12" sm="12"	md="12"	lg="12"	xl="12">
                        Fecha de Vencimiento: {{ documentPrev.adicional.fechaVencimiento | moment('DD/MM/YYYY hh:mm:ss A') }}<br>
                      </b-col>
                    </b-row>
                  </b-alert>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                  <b-alert show variant="success">
                    <b-row>
                      <b-col cols="12" sm="12"	md="12"	lg="12"	xl="6">
                        <strong>Guias Relacionadas:</strong>
                      </b-col>
                      <b-col cols="12" sm="12"	md="12"	lg="12"	xl="6">
                        <ul v-if="documentPrev.guiasRelacionada">
                          <li class="lianticipo" v-for="(item, ind) in documentPrev.guiasRelacionada" :key="ind">
                            {{ item.serie }} - {{ item.numero }}
                          </li>
                        </ul>
                      </b-col>
                    </b-row>
                  </b-alert>
                </b-col>
              </b-row>      
              <b-row>
                <b-col cols="12" sm="12"	md="12"	lg="12"	xl="12">
                  <b-alert show variant="success">
                      <b-row>
                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="6">
                          <strong>Datos Adicionales:</strong>
                        </b-col>
                        <b-col cols="12" sm="12"	md="12"	lg="12"	xl="6">
                          <ul v-if="documentPrev.adicional">
                            <li class="lianticipo" v-for="(item, ind) in documentPrev.adicional.extras" :key="ind">
                              {{ item.clave }} - {{ item.valor }}
                            </li>
                          </ul>
                        </b-col>
                      </b-row>
                  </b-alert>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" sm="6"	md="4"	lg="4"	xl="2"></b-col>
            <b-col cols="12" sm="12"	md="6"	lg="5"	xl="4">
              <b-row>
                <b-col>
                  <div class="text-center">
                    <strong>TOTALES</strong>
                  </div>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col cols="6" sm="6"	md="6"	lg="6"	xl="6">
                  <div><strong>IGV:</strong></div>
                  <div><strong>Venta Gravada:</strong></div>
                  <div><strong>Venta Exonerada:</strong></div>
                  <div><strong>Venta Inafecta:</strong></div>
                  <div><strong>Venta Exportación:</strong></div>
                  <div><strong>Otros Cargos:</strong></div>
                  <div><strong>Venta:</strong></div>
                </b-col>
                <b-col cols="2" sm="2"	md="2"	lg="2"	xl="2">
                  <div>
                    {{ moneda.simbolo }}
                  </div>
                  <div>
                    {{ moneda.simbolo }}
                  </div>
                  <div>
                    {{ moneda.simbolo }}
                  </div>
                  <div>
                    {{ moneda.simbolo }}
                  </div>
                  <div>
                    {{ moneda.simbolo }}
                  </div>
                  <div>
                    {{ moneda.simbolo }}
                  </div>
                  <div>
                    {{ moneda.simbolo }}
                  </div>
                </b-col>
                <b-col cols="4" sm="4"	md="4"	lg="4"	xl="4">
                  <div class="alineacionTotales">
                    <b-form-input class="totales" size="sm" :placeholder="documentPrev.sumatoriaIgv != ''  ? parseFloat(documentPrev.sumatoriaIgv).toFixed(2) : '0.00'" disabled></b-form-input>
                  </div>
                  <div class="alineacionTotales">
                    <b-form-input class="totales" size="sm" :placeholder="documentPrev.totalVentaGravada != null ? parseFloat(documentPrev.totalVentaGravada).toFixed(2) : '0.00'" disabled></b-form-input>
                  </div>
                  <div class="alineacionTotales">
                    <b-form-input class="totales" size="sm" :placeholder="documentPrev.totalVentaExonerada != null ? parseFloat(documentPrev.totalVentaExonerada).toFixed(2) : '0.00'" disabled></b-form-input>
                  </div>
                  <div class="alineacionTotales">
                    <b-form-input class="totales" size="sm" :placeholder="documentPrev.totalVentaInafecta != null  ? parseFloat(documentPrev.totalVentaInafecta).toFixed(2) : '0.00'" disabled></b-form-input>
                  </div>
                  <div class="alineacionTotales">
                    <b-form-input class="totales" size="sm" :placeholder="documentPrev.totalVentaExportacion != null ? parseFloat(documentPrev.totalVentaExportacion).toFixed(2) : '0.00'" disabled></b-form-input>
                  </div>
                  <div class="alineacionTotales">
                    <b-form-input class="totales" size="sm" :placeholder="documentPrev.sumatoriaOtrosCargos != null ? parseFloat(documentPrev.sumatoriaOtrosCargos).toFixed(2) : '0.00'" disabled></b-form-input>
                  </div>
                  <div class="alineacionTotales">
                    <b-form-input class="totales" size="sm" :placeholder="documentPrev.importeTotal != '' ? parseFloat(documentPrev.importeTotal).toFixed(2) : '0.00'" disabled></b-form-input>
                  </div>
                </b-col>
              </b-row>
              <br>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="4" sm="6"	md="8"	lg="8"	xl="8"></b-col>
            <b-col cols="4" sm="3"	md="2"	lg="2"	xl="2">
              <template v-if="!cargandoemision">
                <button class="btn btn-primary botonesemitirPre" @click.prevent="validarImporteTotal"><i class="fa fa-location-arrow"></i> Emitir</button>
              </template>
              <template v-else>
                <button class="btn btn-seconday botonesemitirPre"><i class="fa fa-spin fa-spinner"></i> Emitir</button>
              </template>
            </b-col>
            <b-col cols="4" sm="3"	md="2"	lg="2"	xl="2">
              <template>
                <button class="btn btn-danger botonesemitirPre" @click="backEmision(openPdf)"><i class="fa fa-arrow-circle-left"></i> Atras</button>
              </template>
            </b-col>
        </b-row>
        <vue-snotify></vue-snotify>
    </b-card>
</template>

<script>
import axios from 'axios'
import { TipoMoneda } from '@/shared/utils'
export default {
    props: ['documentPrev', 'tipodoc'],
    name: 'VistaPreEmision',
    data: () => {
        return {
          verDirecciones: false,
          openPdf: {
            idDocumento: 0,
            tipoDoc: 0
          },
          cargandoemision: false,
          tipodemoneda: {
              id: '1',
              codigo: 'PEN',
              descripcion: 'SOLES',
              simbolo: 'S/.'
          },
          listaMoneda: TipoMoneda,
          moneda: {
              id: '1',
              codigo: 'PEN',
              descripcion: 'SOLES',
              simbolo: 'S/.'
          },
          items_fields: [
              {key: 'index', label: 'Item'},
              {key: 'cantidad', label: 'Cantidad', sorteable: true},
              {key: 'descripcion', label: 'Descripción', sorteable: true},
              {key: 'valorUnitario', label: 'Valor Unitario', sorteable: true},
              {key: 'descuento', label: 'Descuento', sorteable: true},
              {key: 'montoAfectacionIgv', label: 'Igv', sorteable: true},
              {key: 'valorVenta', label: 'Valor Total', sorteable: true},
          ],
          rutas: [
              {clave: 1, valor: 'notacredito/emitir' },
              {clave: 2, valor: 'facturas/emitir' }
          ],
          small: true,
          outlined: true
        }
    },
    mounted(){
      this.setMoneda(),
      this.initOpen()
    },
    methods: {
      changeDirection: function () {
        this.verDirecciones = !this.verDirecciones
      },
      setDirection: function (value) {
        this.documentPrev.receptor.direccionFiscal = value.direccion,
        this.documentPrev.adicional.dirAlternativa = value.direccion,
        this.verDirecciones = false
      },
      initOpen: function () {
          this.openPdf.idDocumento = 0,
          this.openPdf.tipoDoc = 0
      },
      setMoneda: function () {
        var parent = this;
        let codigoMoneda = this.documentPrev.tipoMoneda
        parent.listaMoneda.forEach(function(element) {
            if(element.codigo === codigoMoneda){
                parent.moneda.id = element.id,
                parent.moneda.codigo = element.codigo,
                parent.moneda.descripcion = element.descripcion,
                parent.moneda.simbolo = element.simbolo
            }
        });
      },
      validarImporteTotal: function () {
        if(this.importeTotal >= 700 && this.tipoDocumento == '0'){
            this.$swal({
            title: 'Atención!!!',
            text: 'El importe total supera los 700 Soles, debe ingresa número de documento.',
            icon: 'warning',
            buttons: true,
            dangerMode: true
            }).then((willDelete) => {
              this.backEmision(this.openPdf)
            })
        }else{
            this.sendTicket()
        }
      },
      sendTicket: function () {
        let rutaactual = ''
        switch(this.tipodoc) {
            case '1': 
              rutaactual = 'facturas/emitir'
              break;
            case '2': 
              rutaactual = 'boletas/emitir'
              break;
            case '3':  // Para nc de F
              rutaactual = 'notacredito/emitir'
              break;
            case '4':  // Para nc de B
              rutaactual = 'notacredito/emitir'
              break;
            case '5':  // Para nd de F
              rutaactual = 'notadebito/emitir'
              break;
            case '7': 
              rutaactual = 'guiremitente/emitir'
              break;
        }
        this.cargandoemision = true
        axios
          .post(process.env.VUE_APP_API_URL + rutaactual, this.documentPrev,
            this.documentPrev.tipoNotaCredito =='03' ? this.documentPrev.montoTotalImpuestos = 0 : this.documentPrev.montoTotalImpuestos,
            this.documentPrev.tipoNotaCredito =='03' ? this.documentPrev.totalVentaGravada = 0 : this.documentPrev.totalVentaGravada,
            this.documentPrev.tipoNotaCredito =='03' ? this.documentPrev.sumatoriaIgv = 0 : this.documentPrev.sumatoriaIgv ,
            this.documentPrev.tipoNotaCredito =='03' ? this.documentPrev.importeTotal = 0 : this.documentPrev.importeTotal)
          .then(response => (
                this.cargandoemision = false,
                this.info = response.data,
                this.$snotify.success(response.data.msg + ', generando vista previa', 'Éxito'),
                this.redirectEmision(this.info.response, this.tipodoc)
              ))
          .catch(error => (
              this.cargandoemision = true,
              this.catchError(error.response.data),            
              this.backEmision(this.openPdf)
          ))
      },
      redirectEmision: function (value, tipo) {
          switch(tipo) {
            case '1': 
              this.openPdf.idDocumento = value.idFactura,
              this.openPdf.tipoDoc = 1
              break;
            case '2': 
              this.openPdf.idDocumento = value.idBoleta,
              this.openPdf.tipoDoc = 2
              break;
            case '3':  // Para nc de F
              this.openPdf.idDocumento = value.idNotaCredito,
              this.openPdf.tipoDoc = 3
              break;
            case '4':  // Para nc de B
              this.openPdf.idDocumento = value.idNotaCredito,
              this.openPdf.tipoDoc = 4
              break;
            case '5':  // Para nd de F
              this.openPdf.idDocumento = value.idNotaDebito,
              this.openPdf.tipoDoc = 5
              break;
            case '7': 
              this.openPdf.idDocumento = value.idGuiRemitente,
              this.openPdf.tipoDoc = 7
              break;
        }
         this.backEmision(this.openPdf) 
      },
      catchError: function (value) {
        this.cargandoemision = true,
        console.log(value)
          let errorgateway = ''
          let errormessage = ''
          let errordescription = ''
          let mensaje = ''
          if(value.msg){
            errorgateway = value.msg
          }else if(value.response && value.response.message !=''){
            errormessage = value.response.message
          }else if(value.response && value.response.description != ''){
             errordescription = value.response.message
          }else if(value.message){
            mensaje = value.message
          }
          // value.msg ? errorgateway = value.msg: errorgateway = ''
          // value.response.message ? errormessage = value.response.message: errormessage = ''
          // value.response.description ? errordescription = value.response.message: errordescription = ''
          this.$snotify.error(errordescription + ' - ' + errormessage + ' - ' + errorgateway + ' - ' + mensaje, 'Error')
      },
      backEmision: function (value) {
          this.$emit("preEmision", value);
      }
    }
}
</script>

<style>
  .totales{
    width: 80px;
    height: 21px;
    padding-top: -2px;
    padding-bottom: -2px;
    font-size: 14px;
  }
  .botonesemitirPre{
    width: 80px;
    margin-left: 15px;
  }
</style>
